import { render, staticRenderFns } from "./yybg.vue?vue&type=template&id=5de87beb&scoped=true"
import script from "./yybg.vue?vue&type=script&lang=js"
export * from "./yybg.vue?vue&type=script&lang=js"
import style0 from "./yybg.vue?vue&type=style&index=0&id=5de87beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de87beb",
  null
  
)

export default component.exports